<template>
    <div v-cloak style="text-align:center ">
      <el-image :src="imgSrc"></el-image>
    </div>
</template>

<script>


    export default {
        name:'pictureDisplay',
        components: {

        },
        created() {
            this.imgSrc = this.$route.query.imgSrc;
        },
        mounted(){

        },

        data() {
            return {
               imgSrc:""
            }
        },
        methods:{

        }


    }

</script>


<style scoped>
    [v-cloak] {
        display: none;
    }

    .breadcrumb {
        padding: 8px 15px;
        margin-bottom: 20px;
        list-style: none;
        background-color: #f5f5f5;
        border-radius: 4px;
        text-align: left;
    }
    .breadcrumb > li {
        display: inline-block;
    }
    ol, ul {
        margin-top: 0;
    }
    .breadcrumb > li + li::before {
        padding: 0 5px;
        color: #ccc;
        content: "/\A0";
    }
    *, ::after, ::before {
        box-sizing: border-box;
    }

    .area,.area-one {
        text-align: left;
    }


</style>

<!--<template>-->

<!--    <div>TESt</div>-->
<!--</template>-->

<!--<script>-->
<!--    export default {-->
<!--        name : 'commonView'-->
<!--    }-->

<!--</script>-->

<!--<style  scoped>-->


<!--</style>-->



// WEBPACK FOOTER //
// src/components/d1/picture-display.vue